import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DemoLayout from './components/layouts/DemoLayout';
import { DemoProvider } from './contexts/DemoContext';
import DemoDashboardPage from './pages/demo/DemoDashboardPage';
import DemoVendorsPage from './pages/demo/DemoVendorsPage';
import DemoPoliciesPage from './pages/demo/DemoPoliciesPage';
import DemoPolicyDetailPage from './pages/demo/DemoPolicyDetailPage';
import DemoNotificationsPage from './pages/demo/DemoNotificationsPage';

export default function DemoApp() {
  return (
    <DemoProvider>
      <Routes>
        <Route element={<DemoLayout />}>
          <Route path="/demo" element={<DemoDashboardPage />} />
          <Route path="/demo/dashboard" element={<Navigate to="/demo" replace />} />
          <Route path="/demo/vendors" element={<DemoVendorsPage />} />
          <Route path="/demo/policies" element={<DemoPoliciesPage />} />
          <Route path="/demo/policies/:policyId" element={<DemoPolicyDetailPage />} />
          <Route path="/demo/notifications" element={<DemoNotificationsPage />} />
          <Route path="/demo/*" element={<Navigate to="/demo" replace />} />
        </Route>
      </Routes>
    </DemoProvider>
  );
}
